export function toFormValue(value: string | number | null | undefined): string {
  return String(value ?? '');
}

export function idToForm(entity: { id: number } | null | undefined): string {
  return toFormValue(entity?.id);
}

export function optionalNumber(value: string): number | undefined {
  const trimmed = value.trim();
  return trimmed ? Number(trimmed) : undefined;
}

export function optionalTrimmed(value: string): string | undefined {
  return value.trim() || undefined;
}
